/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */
import type { MutationFunction, QueryFunction, QueryKey, UseMutationOptions, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { ApplicationRole, IActionResult, PutCurrentRoleRequest } from '../../model';
import type { ErrorType } from '../../utils/UseCustomInstance';
import { useCustomInstance } from '../../utils/UseCustomInstance';

export const useGetApplicationRolesHook = () => {
    const getApplicationRoles = useCustomInstance<ApplicationRole[]>();

    return (signal?: AbortSignal) => {
        return getApplicationRoles({ url: `/Roles`, method: 'get', signal });
    };
};

export const getGetApplicationRolesQueryKey = () => [`/Roles`] as const;

export const useGetApplicationRolesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetApplicationRolesHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetApplicationRolesHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetApplicationRolesHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetApplicationRolesQueryKey();

    const getApplicationRoles = useGetApplicationRolesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetApplicationRolesHook>>>> = ({ signal }) =>
        getApplicationRoles(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetApplicationRolesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetApplicationRolesHook>>>>;
export type GetApplicationRolesQueryError = ErrorType<unknown>;

export const useGetApplicationRoles = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetApplicationRolesHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetApplicationRolesHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetApplicationRolesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetCurrentApplicationRoleHook = () => {
    const getCurrentApplicationRole = useCustomInstance<string>();

    return (signal?: AbortSignal) => {
        return getCurrentApplicationRole({ url: `/Roles/GetCurrentApplicationRole`, method: 'get', signal });
    };
};

export const getGetCurrentApplicationRoleQueryKey = () => [`/Roles/GetCurrentApplicationRole`] as const;

export const useGetCurrentApplicationRoleQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentApplicationRoleHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentApplicationRoleHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentApplicationRoleHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCurrentApplicationRoleQueryKey();

    const getCurrentApplicationRole = useGetCurrentApplicationRoleHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetCurrentApplicationRoleHook>>>> = ({ signal }) =>
        getCurrentApplicationRole(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetCurrentApplicationRoleQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetCurrentApplicationRoleHook>>>>;
export type GetCurrentApplicationRoleQueryError = ErrorType<unknown>;

export const useGetCurrentApplicationRole = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetCurrentApplicationRoleHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetCurrentApplicationRoleHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetCurrentApplicationRoleQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePutCurrentApplicationRoleHook = () => {
    const putCurrentApplicationRole = useCustomInstance<IActionResult>();

    return (putCurrentRoleRequest: PutCurrentRoleRequest) => {
        return putCurrentApplicationRole({
            url: `/Roles/PutCurrentApplicationRole`,
            method: 'put',
            headers: { 'Content-Type': 'application/json' },
            data: putCurrentRoleRequest,
        });
    };
};

export const usePutCurrentApplicationRoleMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutCurrentApplicationRoleHook>>>,
        TError,
        { data: PutCurrentRoleRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutCurrentApplicationRoleHook>>>,
    TError,
    { data: PutCurrentRoleRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putCurrentApplicationRole = usePutCurrentApplicationRoleHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePutCurrentApplicationRoleHook>>>,
        { data: PutCurrentRoleRequest }
    > = (props) => {
        const { data } = props ?? {};

        return putCurrentApplicationRole(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutCurrentApplicationRoleMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutCurrentApplicationRoleHook>>>>;
export type PutCurrentApplicationRoleMutationBody = PutCurrentRoleRequest;
export type PutCurrentApplicationRoleMutationError = ErrorType<unknown>;

export const usePutCurrentApplicationRole = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutCurrentApplicationRoleHook>>>,
        TError,
        { data: PutCurrentRoleRequest },
        TContext
    >;
}) => {
    const mutationOptions = usePutCurrentApplicationRoleMutationOptions(options);

    return useMutation(mutationOptions);
};
